import { jsx as _jsx } from "react/jsx-runtime";
import CountryLanguagePicker from '../../inputs/CountryLanguagePicker';
var NO_COUNTRIES = [];
var FilterCountryInput = function (_a) {
    var _b = _a.ids, ids = _b === void 0 ? NO_COUNTRIES : _b, setIds = _a.setIds, _c = _a.disabled, disabled = _c === void 0 ? false : _c, label = _a.label;
    return (_jsx(CountryLanguagePicker, { kind: "country", multiple: true, value: ids, onChange: setIds, disabled: disabled, label: label }));
};
export default FilterCountryInput;
